import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putProjectsProjectID,
  type SaveProjectRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useUpdateProjectMutation(projectID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveProjectRequest) =>
      putProjectsProjectID(request, projectID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.all,
        exact: false,
      });
    },
  });
}
